import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import { HrmRequestFormResponse } from '@Types/api/form';
import { TypeDict } from '@Types/index';
import { parseDateTime } from '@Utils/transformDateTime';

import { Languages } from '../../languages';

const fieldSource = (
  data: HrmRequestFormResponse,
  findLeaveType: (requestTypeID: number) => TypeDict | undefined
): Array<{ label: string; value: string | number | boolean }> => {
  const { leaveTypeID, startDate, remarks, reqStatusId, destination } = data;

  const languageLabel = Languages[destination as keyof typeof Languages];

  const source = {
    Status: reqStatusId,
    Purpose: findLeaveType(leaveTypeID)?.codeDesc || '',
    Remarks: remarks || EMPTY_FIELD_PLACEHOLDER,
    'Required Language': languageLabel || EMPTY_FIELD_PLACEHOLDER,
    'Required By': parseDateTime(startDate, 'DD/MM/YYYY'),
  };

  return Object.entries(source).map((item) => ({
    label: item[0],
    value: item[1],
  }));
};

export default fieldSource;
